module.exports = __webpack_public_path__ + "img/icon-twitter.cb4fea0b.svg";